module.exports = __webpack_public_path__ + "static/reed-hastings-ec9a108668b899f72ddac190d8bcf62a.jpg";